import type { PublicBranding } from '@/hooks/useBranding';
import type { PlatformInfo } from '@/hooks/usePlatformInfo';

/** Payload injected by the worker into index.html as
 *  `<script>window.__BOOT__ = {...}</script>`. Lets the SPA render the
 *  right platform name, model counts, and trial amount on first paint
 *  instead of flashing hardcoded fallbacks while the public API queries
 *  resolve. */
type BootPayload = {
  branding?: PublicBranding;
  platform_info?: PlatformInfo;
};

declare global {
  interface Window {
    __BOOT__?: BootPayload;
  }
}

export function getBoot(): BootPayload {
  if (typeof window === 'undefined') return {};
  return window.__BOOT__ ?? {};
}
